import styled from 'styled-components';

export const PopularBusRoutes = styled.section(
  props => `
    margin-bottom: 7rem;
    width: 100%;
    h3 {
        font-size: 2.2rem;
        color: rgb(20, 24, 35);
        font-family: ${props.theme.font.fontFamily};
        font-weight: 600;
        padding-bottom: 1.5rem;
    }
`,
);

export const RouteBlock = styled.section`
  background-color: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.25) 0px 0.1rem 0.4rem 0px;
  border-radius: 0.6rem;
  display: flex;
  flex-direction: column;
  
`;
export const RouteListUl = styled.ul`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  li {
      width: 33%;
      display: flex;
      flex-direction: row;
      padding: 2rem ;
  }
`;
export const BusDetails = styled.div``;
export const CardHeader = styled.p(
  props => `
    font-family: ${props.theme.font.fontFamily};
    font-weight: 600;
    font-size: 1.8rem;
    line-height: 1.2;
    padding-bottom: 0.5rem;
    `,
);
export const SmallTxt = styled.p`
  font-size: 1.2rem;
`;

export const BusIcon = styled.span`
  padding-right: 1rem
`
export const Tabs = styled.div(
  props =>`
  border-bottom: 2px solid rgba(34, 118, 227, 0.1);
`
);

export const TabListUl = styled.ul(
  props =>`
  display: flex;
  flex-direction: row;
  
  li {
    padding: 1.5rem 2rem;
    font-size: 1.6rem;
    list-style-type: none;
    font-weight: 600;
    font-family: ${props.theme.font.fontFamily};
    border-bottom: 2px solid white;
    cursor: pointer;
    margin: 0 1rem;
    &:hover {
      border-bottom: 2px solid #2276e3;
    }
    &.active {
      border-bottom: 2px solid #2276e3;
    }
  }
`
);
